import styles from "./styles.module.css";
import { useState, useContext } from "react";
import useFilterParams from "./useFilterParams";
import { Button } from "@mui/material";
import { LanguageContext } from "App";

const ReceiptFilters = () => {
  const { onFilterChange, getInitialFilters } = useFilterParams();
  const { translations } = useContext(LanguageContext);
  const [filters, setFilters] = useState(getInitialFilters());

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedFilters = { ...filters, [name]: value };
    setFilters(updatedFilters);
  };

  const clearFilters = () => {
    const resetFilters = {
      patientName: "",
      startDate: "",
      endDate: "",
      entryType: "",
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className={styles["filter-container"]}>
      <div className={styles["filter-item"]}>
        <label>Entry Type</label>
        <select
          name="entryType"
          value={filters.entryType}
          onChange={handleInputChange}
        >
          <option value="">All Types</option>
          <option value="AccountingSession">Accounting Session</option>
          <option value="Package">Package</option>
          <option value="UserBalance">User Balance</option>
          <option value="Expense">Expense </option>
          <option value="ServiceBundle">Service Bundle</option>
        </select>
      </div>
      <div className={styles["filter-item"]}>
        <label>Start Date</label>
        <input
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles["filter-item"]}>
        <label>End Date</label>
        <input
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles["filter-item"]}>
        <label>Patient Name</label>
        <input
          type="text"
          name="patientName"
          value={filters.patientName}
          onChange={handleInputChange}
          placeholder="Search by name"
        />
      </div>
      <Button
        style={{ color: "white", backgroundColor: "#3560AD" }}
        variant="contained"
        color="primary"
        onClick={clearFilters}
      >
        {
          translations.createAccountsessionSingleSessionSearchSearchpatientsClear
        }
      </Button>
      <Button
        style={{ color: "white", backgroundColor: "#3560AD" }}
        variant="contained"
        color="primary"
        onClick={() => onFilterChange({ ...filters, page: 1 })}
      >
        {translations.createAccountsessionSingleSessionSearchSearch}
      </Button>
    </div>
  );
};

export default ReceiptFilters;
